import { render } from "./NewRequire.vue?vue&type=template&id=27da3563&scoped=true"
import script from "./NewRequire.vue?vue&type=script&lang=js"
export * from "./NewRequire.vue?vue&type=script&lang=js"

import "./NewRequire.vue?vue&type=style&index=0&id=27da3563&lang=scss&scoped=true"
import "./NewRequire.vue?vue&type=style&index=1&id=27da3563&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27da3563"]])

export default __exports__